import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
import $ from 'jquery'
import router from '../router'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true,

  state: {},

  actions: {
    loadConfig: (context, display) => {
      return new Promise((resolve, reject) => {
        let config = require('../config/config-' + display + '.json')
        context.commit('LOAD_CONFIG', config)
        resolve()
      })
    },
    showNextSlide: (context) => {
      const newSlideID = _.head(context.state.slideOrder)
      const newSlideObject = context.state.allSlides[newSlideID]

      /* set path */
      let path = ''
      if (router.history.current.path.indexOf(router.history.current.params.display + '/') !== -1) {
        path = newSlideObject.type
      } else {
        path = router.history.current.params.display + '/' + newSlideObject.type
      }

      /* route config */
      const routerPath = {
        path: path,
        query: {
          theme: newSlideObject.theme,
          id: newSlideObject.id,
          source: newSlideObject.source,
          sourceTitle: newSlideObject.sourceTitle
        }
      }

      /* auto refresh via timestamp (prod. only) */
      if (process.env.NODE_ENV === 'production') {
        $.get('/static/build-timestamp.json').then((response) => {
          if (context.state.buildTimestamp) {
            if (context.state.buildTimestamp !== response.timestamp) {
              /* flush sw caches */
              self.addEventListener('activate', (event) => {
                event.waitUntil(
                  caches.keys().then((cacheNames) => {
                    return Promise.all(
                      cacheNames.map((cacheName) => {
                        return caches.delete(cacheName)
                      })
                    )
                  })
                )
              })
              setTimeout(() => {
                window.location.reload(true)
              }, 5000)
            }
          } else {
            context.commit('CHANGE_TIMESTAMP', response.timestamp)
          }
        }).fail((error) => {
          console.log(error)
        })
      }

      router.push(routerPath)
      context.commit('CHANGE_ORDER')
    }
  },

  mutations: {
    LOAD_CONFIG: (state, config) => {
      state.slideTimeout = config.slideTimeout
      state.chartAnimationTime = config.chartAnimationTime
      state.chartAnimationEasing = config.chartAnimationEasing
      state.countDuration = config.countDuration
      state.allSlides = _.keyBy(config.slides, 'id')
      state.slideOrder = _.map(config.slides, 'id')
    },
    CHANGE_ORDER: (state, dir) => {
      const order = state.slideOrder
      order.push(order.shift())
    },
    CHANGE_TIMESTAMP: (state, ts) => {
      state.buildTimestamp = ts
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js